const { isSimilar } = require("../helpers/similarityHelper");
const { SIMILARITY_THRESHOLD } = require("../constants");

/**
 * Müşterinin kabul etmediği yük geçmişine göre aracın uygunluğunu kontrol eder.
 * @param {string} vehicleLastProduct - Aracın en son taşıdığı ürün.
 * @param {Array} customers - Müşteriler listesi.
 * @param {string} orderCustomer - Sipariş müşteri adı.
 * @returns {Object} Uyumluluk durumu { isCompatible: boolean, reason: string, rejectedProduct: string }
 */
function checkCargoCompatibility(vehicleLastProduct, customers, orderCustomer) {
  // Null/undefined check for customers array
  if (!customers || !Array.isArray(customers)) {
    return {
      isCompatible: true,
      reason: null,
      rejectedProduct: null
    };
  }

  // Müşteriyi bul
  const customer = customers.find(
    (c) => isSimilar(c.name, orderCustomer, SIMILARITY_THRESHOLD.EXACT_MATCH)
  );

  // Müşteri yoksa veya rejected_loads yoksa uyumlu kabul et
  if (!customer || !customer.rejected_loads) {
    return {
      isCompatible: true,
      reason: null,
      rejectedProduct: null
    };
  }

  // rejected_loads JSON parse et (string ise)
  let rejectedLoads = customer.rejected_loads;
  if (typeof rejectedLoads === 'string') {
    try {
      rejectedLoads = JSON.parse(rejectedLoads);
    } catch (error) {
      console.error('Rejected loads parse hatası:', error);
      return {
        isCompatible: true,
        reason: null,
        rejectedProduct: null
      };
    }
  }

  // Array değilse veya boşsa uyumlu kabul et
  if (!Array.isArray(rejectedLoads) || rejectedLoads.length === 0) {
    return {
      isCompatible: true,
      reason: null,
      rejectedProduct: null
    };
  }

  // Aracın son ürünü yoksa uyumlu kabul et
  if (!vehicleLastProduct) {
    return {
      isCompatible: true,
      reason: null,
      rejectedProduct: null
    };
  }

  // Son ürünün reddedilen yükler listesinde olup olmadığını kontrol et
  const matchedRejectedLoad = rejectedLoads.find(
    (rejectedLoad) => isSimilar(rejectedLoad, vehicleLastProduct, SIMILARITY_THRESHOLD.CLOSE_MATCH)
  );

  if (matchedRejectedLoad) {
    return {
      isCompatible: false,
      reason: `Araç son olarak "${vehicleLastProduct}" taşımış ve müşteri bu yükü kabul etmiyor`,
      rejectedProduct: matchedRejectedLoad
    };
  }

  return {
    isCompatible: true,
    reason: null,
    rejectedProduct: null
  };
}

module.exports = {
  checkCargoCompatibility
};
